// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yFdtgUtZC3ltjLMsfj5AM{display:flex;position:relative}\n", "",{"version":3,"sources":["webpack://src/client/desktop/pages/details/components/product-main-container/style.module.scss"],"names":[],"mappings":"AAAA,uBACI,YAAa,CACb,iBAAkB","sourcesContent":[".ProductMainContainer{\n    display: flex;\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProductMainContainer": "yFdtgUtZC3ltjLMsfj5AM"
};
module.exports = ___CSS_LOADER_EXPORT___;
